<div class="image-container">
  <img class="house-background"
       src="assets/images/house-header-background.svg" />
</div>
